import Model, { attr, belongsTo } from '@ember-data/model';
import PledgeModel from './pledge';

export default class DonorByTimeFrameModel extends Model {
  @attr('string') contactId!: string;
  @attr('number') numberDonations!: number;
  @attr('number') avgDonation!: number;
  @attr('number') lastDonationAmount!: number;
  @attr('string') lastDonationDate!: string;
  @attr('number') totalDonations!: number;
  @belongsTo('pledge', { async: false, inverse: null }) pledge?: PledgeModel;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'donor-by-time-frame': DonorByTimeFrameModel;
  }
}
